import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDirection2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconDirection2"><Path d="M12 9V3.75H18.625C20.0747 3.75 21.25 4.92525 21.25 6.375C21.25 7.82475 20.0747 9 18.625 9H12ZM12 9V14M12 9H5.25C3.86929 9 2.75 10.1193 2.75 11.5C2.75 12.8807 3.86929 14 5.25 14H12M12 14V20.25M12 20.25H7.75M12 20.25H16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconDirection2;
